import { useCallback } from 'react';

import { useCheckBoxError, useForm } from '../hooks';

import CheckBox from './CheckBox';
import { get as _get } from 'lodash';


export interface FormCheckBoxProps {
	id: string;
	description: string | JSX.Element;
	readOnly?: boolean;
}

export const FormCheckBox: React.FC<FormCheckBoxProps> = ({ id, description, readOnly = false }) => {
	const form = useForm();
	const checkBoxError = useCheckBoxError(id);

	const handleChange = useCallback(async (value: boolean) => {
		await form.setFieldValue(id, value, true);
		await form.setFieldTouched(id);
	}, [form, id]);

	return (
		<CheckBox
			checked={_get(form.values, id)}
			error={checkBoxError}
			onChange={handleChange}
			children={description}
			readOnly={readOnly}
		/>
	);
}

